import styled from 'styled-components';
import CheckSvg from 'library/icons/check.svg';

const StyledContainer = styled.div`
  box-shadow: 1px 3px 7px 0 rgba(0,0,0,0.05);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  transition: all .15s ease-in-out;

  &:hover {
    transform: scale(1.01);
    box-shadow: 1px 6px 7px 0 rgba(0,0,0,0.25)
  }

  &:active {
    transform: scale(0.98);
  }
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckBox = styled.div`
  background-color: #F9E4A4;
  border-radius: 4px;
  height: 54px;
  width: 100%;
  display: flex;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
`;

const StyledLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  margin: auto .5em;
  width: 100%;

  @media (min-width: 600px) {
    font-size: 22px;
  }
`;

const StyledBox = styled.div`
  background: #fff;
  text-align: center;
  color: #797979;
  width: 30px;
  height: 25px;
  margin: auto .5em;
  display: flex;
  span {
    width: 100%;
    height: 100%;
    font-size: 16px;
    font-weight: bold;
  }
`;

const StyledCheckSvg = styled(CheckSvg)`
  g {
    g {
      fill: green;
    }
  }
`;

export {
  StyledContainer,
  HiddenCheckbox,
  StyledCheckBox,
  StyledLabel,
  StyledBox,
  StyledCheckSvg
};